/* eslint-disable */

/*
 *
 *   INSPINIA - Responsive Admin Theme
 *   version 2.4
 *
 */


function init() {
  // Collapse ibox function
  $('.collapse-link').click(function () {
    var ibox = $(this).closest('div.ibox');
    var button = $(this).find('i');
    var content = ibox.find('div.ibox-content');
    content.slideToggle(200, ()=>{
      try {
        window.iboxOnResize();
      } catch (e) {
        //
      }
    });
    button.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
    ibox.toggleClass('').toggleClass('border-bottom');
    $('.iboxLabel').toggle();
    setTimeout(function () {
      ibox.resize();
      ibox.find('[id^=map-]').resize();
    }, 50);
  });

}

$(document).ready(() => {
  init();
});



// WEBPACK FOOTER //
// ./es6/admin-common-js/ui/ibox.js